(function () {
  'use strict';

  const partner = sessionStorage.getItem('partner');

  if (!partner) return;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {

      if (cart.attributes && cart.attributes.partner === partner) {
        console.log('Partner ya estaba en el carrito.');
        return;
      }

      console.log('Guardando partner en el carrito...');

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            partner: partner
          }
        })
      });

    })
    .then(() => {
      console.log('Partner enviado al carrito.');
    })
    .catch(console.error);

})();